/**
 * @generated SignedSource<<0d1caf361759a10f97d849046a9a6707>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ServiceMutationsHighlightedItemRemoveServiceMutation$variables = {
  pid: string;
  sid: string;
};
export type ServiceMutationsHighlightedItemRemoveServiceMutation$data = {
  readonly removeHighlightedSeaService: {
    readonly id: string;
  };
};
export type ServiceMutationsHighlightedItemRemoveServiceMutation = {
  response: ServiceMutationsHighlightedItemRemoveServiceMutation$data;
  variables: ServiceMutationsHighlightedItemRemoveServiceMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'pid',
      },
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'sid',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'pid',
            variableName: 'pid',
          },
          {
            kind: 'Variable',
            name: 'sid',
            variableName: 'sid',
          },
        ],
        concreteType: 'Profile',
        kind: 'LinkedField',
        name: 'removeHighlightedSeaService',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'id',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'ServiceMutationsHighlightedItemRemoveServiceMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'ServiceMutationsHighlightedItemRemoveServiceMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '0d3a1ec1d4414f9b4a39768206313250',
      id: null,
      metadata: {},
      name: 'ServiceMutationsHighlightedItemRemoveServiceMutation',
      operationKind: 'mutation',
      text: 'mutation ServiceMutationsHighlightedItemRemoveServiceMutation(\n  $pid: ID!\n  $sid: ID!\n) {\n  removeHighlightedSeaService(pid: $pid, sid: $sid) {\n    id\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'b4815b50cb2235e2ce142ab908881370';

export default node;
